<template>
  <div>
    <v-row align="center"
           style="min-height: 70vh"
           v-if="loadingSettings">
      <v-col cols="12" class="text-center">
        <v-progress-circular color="kbGreen"
                             indeterminate
                             size="60">
        </v-progress-circular>
      </v-col>
    </v-row>

    <v-row align="center"
           style="min-height: 70vh"
           v-else-if="errorLoadingSettings">
      <v-row>
        <v-col class="text-center"
               cols="12">
          <v-icon color="error"
                  size="50px">
            mdi-alert
          </v-icon>
        </v-col>

        <v-col class="text-center text-h6"
               cols="12">
          {{ $t('general.errorLoadingSettings') }}
        </v-col>

        <v-col class="text-center"
               cols="12">
          <v-btn @click="reload"
                 color="kbGreen"
                 dark>
            {{ $t('general.reload') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-row>

    <v-row v-else>
      <v-tabs align-with-title
              background-color="kbWhite"
              show-arrows
              v-model="tab">
        <v-tabs-slider color="kbGreen"></v-tabs-slider>

        <v-tab v-for="item in tabsItems" :key="item" style="text-transform: capitalize">
          {{ item }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon color="kbRed"
                      right
                      small
                      v-if="item === 'Autenticación' || item === 'Canales'"
                      v-on="on">
                mdi-lock
              </v-icon>
            </template>

            <span>{{$t('general.administratorsOnly')}}</span>
          </v-tooltip>
        </v-tab>
      </v-tabs>

      <v-row class="px-2">
        <v-col cols="12">
          <v-tabs-items v-model="tab">
            <!--          Autenticacion-->
            <v-tab-item v-if="isSuperAdmin">
              <v-card color="kbWhite" flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="text-h6 kbDarkBlueText--text">
                      {{ $t('general.authenticationType') }}
                    </v-col>

                    <v-col cols="12">
                      <v-divider/>
                    </v-col>

                    <v-col cols="12">
                      <v-select :items="authMethodItems"
                                item-text="label"
                                item-value="value"
                                :label="$t('general.authenticationType')"
                                v-model="chat.authMethod">
                      </v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-radio-group mandatory
                                     row
                                     v-model="chat.authMethod">
                        <v-radio color="kbDarkBlueText"
                                 :label="$t('general.noAuthentication')"
                                 value="none">
                        </v-radio>

                        <v-radio color="kbDarkBlueText"
                                 :label="$t('general.externalAuthentication')"
                                 value="external">
                        </v-radio>

                        <v-radio color="kbDarkBlueText"
                                 :label="$t('general.form')"
                                 value="form">
                        </v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field :label="$t('general.serverUrl')" v-model="chat.urlBase"></v-text-field>
                    </v-col>

                    <v-col cols="12" v-if="chat.authMethod === 'form'">
                      <v-checkbox :label="$t('general.name')"
                                  color="kbDarkBlueText"
                                  value="name"
                                  v-model="chat.formFields">
                      </v-checkbox>

                      <v-checkbox :label="$t('general.email')"
                                  color="kbDarkBlueText"
                                  value="email"
                                  v-model="chat.formFields">
                      </v-checkbox>

                      <v-checkbox :label="$t('general.phone')"
                                  color="kbDarkBlueText"
                                  value="phone"
                                  v-model="chat.formFields">
                      </v-checkbox>

                      <v-checkbox :label="$t('general.city')"
                                  color="kbDarkBlueText"
                                  value="city"
                                  v-model="chat.formFields">
                      </v-checkbox>

                      <v-checkbox :label="$t('general.showTermsAndConditionsOfUse')"
                                  color="kbDarkBlueText"
                                  v-model="chat.showTermsAndConditions">
                      </v-checkbox>

                      <div style="border: 1px grey dashed; border-radius: 8px; padding: 8px; margin: 8px 0;"
                           v-if="chat.showTermsAndConditions">
                        {{ $t('general.buildTheTermsAndConditionsMessage')}}

                        <v-text-field :placeholder="$t('general.enterTheTextThatWillAppearInTheTermsAndConditions')"
                                      v-model="textOfTermsAndConditions"
                                      :rules="[rules.keybeLink]">
                        </v-text-field>

                        <v-menu>
                          <template v-slot:activator="{ on }">
                            <v-btn class="mb-2"
                                   color="kbGreen"
                                   dark
                                   v-on="on">
                              {{ $t('general.selectTheTypeOfLink') }}
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item @click="addLink(i)" v-for="i in typeLinks" :key="i">
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{i}}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>

                        <v-text-field :label="$t('general.termsAndConditionsLink')"
                                      color="kbDarkBlue"
                                      v-model="chat.linkOfTermsAndConditions">
                        </v-text-field>

                        <v-color-picker elevation="1"
                                        hide-mode-switch
                                        mode="hexa"
                                        v-model="chat.termsAndConditionsLinkColor"
                                        flat>
                        </v-color-picker>

                        <div class="my-2">{{ $t('general.result') }}</div>

                        <div class="terms-and-conditions-settings"
                             v-html="htmlOfTermsAndConditions">
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-spacer></v-spacer>
                  <v-row>
                    <v-col cols="12" class="text-h6 kbDarkBlueText--text">
                      {{ $t('general.twoFactorAuthentication') }}
                    </v-col>

                    <v-col cols="12">
                      <v-divider/>
                    </v-col>
                    <v-col cols="12">
                      <v-radio-group row v-model="chat.authTwoFactor">
                        <v-radio color="kbDarkBlueText"
                                 :label="$t('general.onDemand')"
                                 value="onDemand">
                        </v-radio>

                        <v-radio color="kbDarkBlueText"
                                 :label="$t('general.onStartup')"
                                 value="onStartup">
                        </v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field :label="$t('general.confirmationTimeout')"
                                    v-model="chat.authorizationTimeout">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!--          Finalization-->
            <v-tab-item v-if="isSuperAdmin">
              <v-card color="kbWhite">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="text-h6 kbDarkBlueText--text">
                      {{$t('general.setTheEndTimeForConversations')}}
                    </v-col>

                    <v-col cols="12">
                      <v-divider/>
                    </v-col>

                    <v-col cols="12">
                      <v-row class="flex-wrap">
                        <v-col cols="12">
                          <v-switch :label="$t('general.automaticallyEndUnansweredConversations')"
                                    v-model="chat.endUnansweredConversations"
                                    color="kbGreen">
                          </v-switch>
                        </v-col>
                      </v-row>
                    </v-col>

                    <div v-if="chat.endUnansweredConversations">
                      <v-col class="text-h6 kbDarkBlueText--text"
                             cols="12" style="padding-bottom: 0px">
                        {{$t('general.definesTheTimeUserStopsResponding')}}
                      </v-col>

                      <v-col cols="12"
                             style="height: 30px">
                      <span class="red--text"
                            v-show="showErrorTime">
                        {{ $t('general.pickATimeGreaterOrEqualThan15Minutes') }}
                      </span>
                      </v-col>

                      <v-col cols="12"
                             style="font-size: 16px">
                      <span class="text-h6 kbDarkBlueText--text mb-4">
                        {{ $t('general.conversationWithAdviser') }}
                      </span>

                      <br>

                      <span class="mr-4 mb-4">
                        {{$t('general.finishAfter')}} (HH:mm):
                      </span>

                      <vue-timepicker hide-disabled-items
                                      hide-clear-button
                                      class="timeInput"
                                      format="HH:mm"
                                      :hour-range="[[0, 8]]"
                                      :minute-range="[0, 15, 30, 45]"
                                      v-model="formattedEndTimeAdvisor"
                                      style="cursor: pointer;">
                        </vue-timepicker>

                        <v-text-field counter
                                      color="kbDarkBlueText"
                                      :label="$t('general.enterTheReasonForAutomaticCompletion')"
                                      maxlength="50"
                                      v-model="chat.customizedEndReasonAdvisor"
                                      style="width: 90%">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12"
                             style="font-size: 16px">
                      <span class="text-h6 kbDarkBlueText--text mb-4">
                        {{ $t('general.conversationWithAI') }}
                      </span>

                        <br>

                        <span class="mr-4 mb-4">
                        {{$t('general.finishAfter')}} (HH:mm):
                      </span>

                        <vue-timepicker hide-disabled-items
                                        hide-clear-button
                                        class="timeInput"
                                        format="HH:mm"
                                        :hour-range="[[0, 8]]"
                                        :minute-range="[0, 15, 30, 45]"
                                        v-model="formattedEndTimeBot"
                                        style="cursor: pointer;">
                        </vue-timepicker>

                        <v-text-field counter
                                      color="kbDarkBlueText"
                                      :label="$t('general.enterTheReasonForAutomaticCompletion')"
                                      maxlength="50"
                                      v-model="chat.customizedEndReasonBot"
                                      style="width: 90%">
                        </v-text-field>
                      </v-col>
                    </div>

                    <v-col cols="12" class="text-h6 kbDarkBlue--text">
                      {{ $t('general.waitingMessages') }}
                    </v-col>

                    <v-col cols="12">
                      <v-divider/>
                    </v-col>

                    <v-col cols="12">
                      <v-row class="flex-wrap">
                        <v-col cols="12">
                          <v-switch :label="$t('general.sendMessageToUserWhileWaitingToBeAttended')"
                                    v-model="chat.advisorInactivity"
                                    color="kbGreen">
                          </v-switch>
                        </v-col>
                      </v-row>
                    </v-col>
                    <div v-if="chat.advisorInactivity">

                    <v-col class="text-h6 kbDarkBlue--text"
                           cols="12" style="padding-bottom: 0px">
                      {{ $t('general.defineWaitingMessages') }}
                    </v-col>

                    <v-col cols="12"
                             style="height: 30px">
                      <span class="red--text"
                            v-show="showErrorTimeInactivity">
                        {{ $t('general.theTimeCannotBeGreaterThanOrEqualToTheEndTime') }}
                      </span>
                    </v-col>

                    <v-col cols="12"
                           style="font-size: 16px">
                      <span class="text-h6 kbDarkBlue--text mb-4">
                        {{ $t('general.definesTheTimeToSendAMessageWhenTheUserIsWaitingForAnAdvisor') }}
                      </span>

                      <br>

                      <span class="mr-4 mb-4">
                        {{ $t('general.shipAfter') }}:
                      </span>

                      <vue-timepicker hide-disabled-items
                                        hide-clear-button
                                        class="timeInput"
                                        format="HH:mm"
                                        :hour-range="[[0, 1, 2, 3, 4, 5]]"
                                        :minute-range="[3, 5, 7, 10, 15, 30, 45]"
                                        v-model="formattedReady4Time"
                                        style="cursor: pointer;">
                      </vue-timepicker>

                      <v-text-field counter
                                    color="kbDarkBlue"
                                    :label="$t('general.enterMessageExThereAreNoAgentsAvailableWeWillAssistYouSoon')"
                                    maxlength="80"
                                    v-model="chat.ready4InactivityMessage"
                                    style="width: 120%">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12"
                           style="font-size: 16px">
                      <span class="text-h6 kbDarkBlue--text mb-4">
                        {{ $t('general.definesTheTimeToSendAMessageWhenTheAdvisorDoesNotRespondToTheUser') }}
                      </span>

                      <br>

                      <span class="mr-4 mb-4">
                        {{ $t('general.shipAfter') }}:
                      </span>

                      <vue-timepicker hide-disabled-items
                                      hide-clear-button
                                      class="timeInput"
                                      format="HH:mm"
                                      :hour-range="[[0, 1, 2, 3, 4, 5]]"
                                      :minute-range="[3, 5, 9, 10, 15, 30, 45]"
                                      v-model="formattedAdvisorTime"
                                      style="cursor: pointer;">
                      </vue-timepicker>

                      <v-text-field counter
                                    color="kbDarkBlue"
                                    :label="$t('general.pleaseEnterYourMessageExWeAreVerifyingGiveUsAMomentPlease')"
                                    maxlength="80"
                                    v-model="chat.advisorInactivityMessage"
                                    style="width: 120%">
                      </v-text-field>
                    </v-col>
                  </div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!--          Apariencia-->
          <v-tab-item>
            <v-card color="kbWhite" flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-h6 kbDarkBlueText--text">
                    {{ $t('general.appearance') }}
                  </v-col>

                  <v-col cols="12">
                    <v-divider/>
                  </v-col>

                  <v-col cols="12">
                    <v-radio-group v-model="chat.theme" row>
                      <v-radio :label="$t('general.light')"
                               color="kbDarkBlueText"
                               value="light">
                      </v-radio>

                      <v-radio :label="$t('general.dark')"
                               color="kbDarkBlueText"
                               value="dark">
                      </v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" class="text-h6">
                    {{$t('general.position')}}
                  </v-col>

                  <v-col cols="12">
                    <v-radio-group v-model="chat.position" row>
                      <v-radio :label="$t('general.left')"
                               color="kbDarkBlueText"
                               value="left">
                      </v-radio>

                      <v-radio :label="$t('general.right')"
                               color="kbDarkBlueText"
                               value="right">
                      </v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" class="text-h6">
                    {{ $t('general.pickAMainColor') }}
                  </v-col>

                  <v-col cols="12">
                    <v-color-picker elevation="1"
                                    hide-mode-switch
                                    mode="hexa"
                                    v-model="chat.mainColor"
                                    flat>
                    </v-color-picker>
                  </v-col>

                  <v-col cols="12">
                    <ImagePicker v-model="chat.logo"
                                 :title="$t('general.customLogo')">
                    </ImagePicker>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field counter
                                  color="kbDarkBlueText"
                                  :label="$t('general.customTitle')"
                                  maxlength="25"
                                  v-model="chat.title">
                    </v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field counter
                                  color="kbDarkBlueText"
                                  :label="$t('general.customBubbleMessage')"
                                  maxlength="50"
                                  v-model="chat.bubbleMessage">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-select :items="languageItems"
                              :label="$t('general.defaultLanguage')"
                              v-model="chat.language">
                    </v-select>
                  </v-col>

                  <v-col cols="12">
                    <v-checkbox color="kbDarkBlue"
                                :label="isCloudTask ? $t('general.hidePoweredByCloudtask') : $t('general.hidePoweredByKeybe')"
                                v-if="isSuperAdmin"
                                v-model="chat.hidePoweredByKeybe">
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" class="text-h6">
                    {{ $t('general.automaticallyOpenTheChat') }}
                  </v-col>

                    <v-col cols="12">
                      <CustomMultipleTextField color="kbDarkBlue"
                                               :label="$t('general.enterTheUrlOfTheWebsitesThatWillAutomaticallyOpenTheChat')"
                                               v-model="chat.urlsAutoOpen">
                      </CustomMultipleTextField>
                    </v-col>

                    <v-col cols="12" class="text-h6">
                      Multimedia
                      <v-menu
                        open-on-hover
                        right
                        offset-y>
                        <template v-slot:activator="{ on }">
                          <v-icon color="kbGrey"
                                  right
                                  small
                                  v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>

                       <v-img src="https://storage.googleapis.com/keybe/images/dashboard/multimedia-configurations-help.png"/>
                      </v-menu>
                    </v-col>
                    <v-col cols="12">

                    </v-col>

                    <v-col cols="12">
                      <v-checkbox color="kbDarkBlue"
                                  :label="$t('general.disableChatMedia')"
                                  v-model="chat.disableMultimedia">
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

<!--          Personaliza tu conversacion-->
          <v-tab-item>
            <v-card color="kbWhite">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-switch disabled
                              :label="$t('general.showEmojis')"
                              v-model="chat.showEmojis">
                    </v-switch>
                  </v-col>

                  <v-col class="text-h6 kbDarkBlueText--text">
                    {{ $t('general.customQuestions') }}
                  </v-col>

                  <v-col cols="12">
                    <CustomMultipleTextField color="kbDarkBlueText"
                                             :label="$t('general.insertChatQuestions')"
                                             :limit="5"
                                             v-model="chat.customizedQuestions">
                    </CustomMultipleTextField>
                  </v-col>

                  <v-col class="text-h6 kbDarkBlueText--text">
                    {{ $t('general.permanentMessages') }}
                  </v-col>

                  <v-col cols="12">
                    <CustomMultipleTextField color="kbDarkBlueText"
                                             :label="$t('general.insertFirstChatMessages')"
                                             :limit="5"
                                             v-model="chat.permanentMessages">
                    </CustomMultipleTextField>
                  </v-col>

                  <v-col class="text-h6 kbDarkBlueText--text"
                         cols="12">
                    {{ $t('general.reasonsOfFinishedConversation') }}
                  </v-col>

                  <v-col cols="12">
                    <CustomMultipleTextField color="kbDarkBlueText"
                                             :label="$t('general.possibleReasonsAdvisorEndConversation')"
                                             v-model="chat.finishOptions">
                    </CustomMultipleTextField>
                  </v-col>

                  <v-col class="text-h6 kbDarkBlueText--text"
                         cols="12">
                    {{ $t('general.quickResponses') }}
                  </v-col>

                  <v-col cols="12">
                    <CustomMultipleTextField color="kbDarkBlueText"
                                             :label="$t('general.insertQuickResponsesForAdvisors')"
                                             v-model="chat.quickResponses">
                    </CustomMultipleTextField>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

<!--          Horarios-->
          <v-tab-item>
            <v-card color="kbWhite">
              <v-card-text>
                <v-row>
                  <v-col class="text-h6 kbDarkBlueText--text"
                         cols="12">
                    {{ $t('general.inactivityMessage') }}
                  </v-col>

                  <v-col cols="12">
                    <v-switch :label="$t('general.enableInactivityMessage')"
                              v-model="chat.enableInactivity">
                    </v-switch>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field counter
                                  :label="$t('general.insertInactivityMessage')"
                                  maxlength="100"
                                  v-model="chat.inactivityMessage">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field :label="$t('general.timeForTriggeringInactivityMessage')"
                                  type="number"
                                  v-model="chat.inactivitySeconds">
                    </v-text-field>
                  </v-col>

                  <v-col class="text-h6 kbDarkBlueText--text"
                         cols="12">
                    {{ $t('general.attentionSchedule') }}
                  </v-col>

                  <v-col cols="12">
                    <v-text-field :label="$t('general.outOfServiceMessage')"
                                  color="kbDarkBlueText"
                                  v-model="chat.workingHours.message">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field :label="$t('general.customFormMessage')"
                                  v-model="chat.workingHours.customFormTitle">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-switch :label="$t('general.blockMessageComposer')"
                              v-model="chat.workingHours.blockMessageComposer">
                    </v-switch>
                  </v-col>

                  <v-col cols="12">
                    <v-autocomplete :label="$t('general.timeZone')"
                                    :items="timeZones"
                                    item-text="label"
                                    return-object
                                    v-model="chat.timeZone">
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12">
                    <v-row>
                      <template v-for="(day, index) in chat.workingHours.days">
                        <v-col cols="12"
                               :key="index"
                               md="4"
                               sm="6">

                          <v-card>
                            <v-card-title>
                              {{$t(`general.${days[index]}`)}}
                            </v-card-title>
                            <v-card-text>
                              <div>
                                <v-switch :label="$t('general.nonWorkingDay')"
                                          v-model="day.isClosed"
                                          style="display: inline-flex">
                                </v-switch>
                              </div>

                              <div v-if="day.isClosed">
                                <v-alert type="error"
                                         :value="true">
                                  {{$t('general.nonWorkingDay')}}
                                </v-alert>
                              </div>

                              <div v-else-if="!day.schedules || day.schedules.length === 0">
                                <v-alert type="info"
                                         :value="true">
                                  {{$t('general.allDay')}}
                                </v-alert>
                              </div>

                              <div v-if="!day.isClosed">
                                <div style="display: inline-flex; align-items: center"
                                     :key="`${day.code} + ${index2}`"
                                     v-for="(schedule, index2) in day.schedules">

                                  <v-text-field @click="openTimePicker(index, index2, 'from')"
                                                v-model="schedule.from"
                                                :label="$t('general.from')"
                                                readonly
                                                :rules="[
                                                  rules.required,
                                                  timeRules.checkHours(index2 > 0 ? day.schedules[index2 - 1].until : '00:00', schedule.from)
                                                ]">
                                  </v-text-field>

                                  <v-text-field @click="openTimePicker(index, index2, 'until')"
                                                class="pl-2"
                                                v-model="schedule.until"
                                                :label="$t('general.until')"
                                                readonly
                                                :rules="[
                                                  rules.required,
                                                  timeRules.checkHours(schedule.from, schedule.until)
                                                ]">
                                  </v-text-field>

                                  <v-btn icon
                                         @click="removeSchedule(day, index2)">
                                    <v-icon>
                                      mdi-delete
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </div>
                            </v-card-text>

                            <v-divider/>

                            <v-card-actions class="justify-end" v-if="!day.isClosed && day.schedules.length !== 4">
                              <v-btn @click="addSchedule(day)" text>
                                {{$t('general.addSchedule')}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </template>
                    </v-row>
                  </v-col>

                  <v-dialog @input="closeTimePicker()"
                            max-width="300px"
                            v-model="showTimePicker">
                    <v-toolbar color="primary" dark flat>
                      <v-toolbar-title>
                        {{$t(`general.${days[selectedSchedule.day]}`)}}
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-time-picker color="primary"
                                   format="24hr"
                                   style="border-radius: 0; box-shadow: none"
                                   v-if="showTimePicker"
                                   v-model="timePickerValue">
                      <v-spacer/>
                      <v-btn text
                             color="primary"
                             @click="closeTimePicker()">
                        {{$t('general.cancel')}}
                      </v-btn>

                      <v-btn text
                             color="primary"
                             @click="saveSchedule()">
                        {{$t('general.accept')}}
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

<!--          Asignacion-->
          <v-tab-item>
            <v-card color="kbWhite">
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-h6 kbDarkBlueText--text">
                    {{ $t('general.advisors') }}
                  </v-col>

                  <v-col cols="12">
                    <v-divider/>
                  </v-col>

                    <v-col cols="12">
                      <v-row class="flex-wrap">
                        <v-col cols="12" md="7">
                          <v-switch :label="$t('general.assignConversationsAutomaticallyToConnectedAdvisors')"
                                    v-model="chat.automaticallyAssignAdvisorsWaitingForConversations"
                                    color="kbGreen"
                                    @change="assignChange = true">
                          </v-switch>
                        </v-col>
                      </v-row>
                    </v-col>

                  <v-col class="text-h6 kbDarkBlueText--text"
                         cols="12">
                    {{$t('general.tagsAsAMethodOfAutoAssignment')}}
                  </v-col>

                  <v-col cols="12">
                    <CustomMultipleTextField color="kbDarkBlueText"
                                             :label="$t('general.enterTags')"
                                             :clean="true"
                                             v-model="appTags">
                    </CustomMultipleTextField>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="kbLightBlue"
                           dark
                           @click="submit('tags')"
                           :loading="loading">
                      {{$t('general.updateTags')}}
                    </v-btn>
                  </v-col>

                  <v-col cols="12">
                    <v-checkbox color="kbLightBlue"
                                :label="$t('general.showOnlyConnectedAdvisors')"
                                v-model="chat.showConnectedAdvisorsOnly">
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

<!--          Canales-->
          <v-tab-item v-if="isSuperAdmin">
            <v-card color="kbWhite">
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-h6 kbDarkBlueText--text">
                    {{$t('general.communicationChannels')}}
                  </v-col>

                  <v-col cols="12">
                    <v-divider/>
                  </v-col>

                  <v-col cols="12">
                    <v-expansion-panels class="custom-expansion-panels"
                                        :accordion=false
                                        :hover=true>
                      <v-expansion-panel>
                        <v-expansion-panel-header class="text-h6">
                          Facebook Messenger
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <Facebook/>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel>
                        <v-expansion-panel-header class="text-h6">
                          Whatsapp
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <Smooch/>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel v-if="showDevelopment">
                        <v-expansion-panel-header class="text-h6">
                          Google
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-card color="kbWhite" flat>
                            <v-card-text>
                              <v-row v-if="connectedEmails.length === 0">
                                <v-col cols="12">
                                  {{$t('general.youMustPreviouslyGrantKeybeGooglePermission')}}
                                </v-col>

                                <v-col cols="12">
                                  <v-btn @click="connectWithGoogle()"
                                         color="red"
                                         dark>
                                    {{$t('general.connectWithGoogle')}}
                                  </v-btn>
                                </v-col>
                              </v-row>

                              <v-row v-else>
                                <v-col cols="12">
                                  {{$t('general.youHaveCurrentlyAuthorizedKeybe')}} <b>{{connectedEmails.toString()}}</b>
                                  <span v-if="gmailIsConnected"> {{$t('general.andYouHaveCorrectlyConfiguredGmail')}}</span>
                                </v-col>

                                <v-col cols="12">
                                  <v-btn @click="connectionWithGmail()"
                                         color="red"
                                         dark
                                         :loading="loadingGmail">
                                    {{gmailIsConnected ? $t('general.disconnectFromGmail') : $t('general.connectToGmail')}}
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-col cols="12">
      <v-btn block
             @click="submit('chat')"
             color="kbPurple"
             dark
             large
             :loading="loading">
        {{ $t('general.saveChanges') }}
      </v-btn>
    </v-col>

    <AttachChat v-model="showAttachChatDialog"/>

      <v-btn @click="showAttachChatDialog = true"
             color="kbPurple"
             dark
             style="position: fixed; right: 16px; bottom: 80px; z-index: 1"
             fab>
        <v-icon>
          mdi-paperclip
        </v-icon>
      </v-btn>

      <v-btn bottom
             @click="submit('chat')"
             color="kbPurple"
             dark
             fab
             fixed
             :loading="loading"
             right>
        <v-icon>
          mdi-cloud-sync
        </v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import AttachChat from '@/pages/App/Conversations/Settings/AttachChat.vue'
import CustomMultipleTextField from '@/pages/App/Conversations/Settings/CustomMultipleTextField.vue'
import Facebook from '@/pages/App/Conversations/Settings/FacebookMessenger'
import ImagePicker from '@/pages/App/Events/dialogs/ImagePicker.vue'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import notifications from '@/libs/notifications.js'
import rules from '@/libs/rules'
import Smooch from '@/pages/App/Conversations/Settings/Smooch'
import timeZones from '@/libs/timeZones.js'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import conversationsService from '@/services/conversationsService.js'

export default {
  components: { AttachChat, CustomMultipleTextField, Facebook, ImagePicker, Smooch, VueTimepicker },
  computed: {
    ...mapGetters(['isSuperAdmin']),
    ...mapState({
      language: state => state.auth.language,
      isCloudTask: state => state.auth.isCloudTask,
      selectedApp: state => state.apps.selectedApp
    }),
    htmlOfTermsAndConditions () {
      if (!this.textOfTermsAndConditions) return this.$t('general.youHaveNotEnteredDataYet')

      const text = this.textOfTermsAndConditions.replace(/{{keybe}}/g, `<a href="https://keybe.ai/privacidad/" target="_blank" style="font-weight: bold; color: ${this.chat.termsAndConditionsLinkColor.hex}">Keybe</a>`)
      return text.replace(/{{app}}/g, '<a href="' + this.chat.linkOfTermsAndConditions + `" target="_blank" style="font-weight: bold; color: ${this.chat.termsAndConditionsLinkColor.hex}">` + this.selectedApp.app_name + '</a>')
    },
    showDevelopment () {
      return process.env.VUE_APP_NODE_ENV === 'development' || process.env.VUE_APP_NODE_ENV === 'test'
    },
    tabsItems () {
      if (this.isSuperAdmin) {
        return [this.$t('general.authentication'), this.$t('general.finalization'), this.$t('general.appearance'), this.$t('general.customizeYourConversation'), this.$t('general.schedules'), this.$t('general.assignment'), this.$t('general.channels')]
      }

      return [this.$t('general.appearance'), this.$t('general.customizeYourConversation'), this.$t('general.schedules'), this.$t('general.assignment')]
    },
    showErrorTime () {
      if (this.chat.endUnansweredConversations) {
        if (this.formattedEndTimeAdvisor === '00:00' || this.formattedEndTimeBot === '00:00') return true
      }
      return false
    },
    showErrorTimeInactivity () {
      if (this.chat.advisorInactivity && this.chat.endUnansweredConversations) {
        if (this.formattedReady4Time >= this.formattedEndTimeAdvisor ||
          this.formattedReady4Time >= this.formattedEndTimeBot ||
          this.formattedAdvisorTime >= this.formattedEndTimeBot ||
          this.formattedAdvisorTime >= this.formattedEndTimeAdvisor) return true
      }
      return false
    }
  },
  async created () {
    try {
      this.errorLoadingSettings = false
      this.loadingSettings = true
      const appInfo = await this.$store.dispatch('getAppInfo', { getStatistics: false })
      this.$store.commit('SET_APP_INFO', appInfo)
      const chatSettings = this.$store.getters.chatSettings
      if (chatSettings.authMethod) this.$set(this, 'chat', chatSettings)

      const defaultTimeEnd = '00:15'
      const defaultTimeInactivity = '00:03'

      this.$set(this, 'formattedAdvisorTime', chatSettings.formattedAdvisorTime || defaultTimeInactivity)
      this.$set(this, 'formattedReady4Time', chatSettings.formattedReady4Time || defaultTimeInactivity)
      this.$set(this, 'formattedEndTimeAdvisor', chatSettings.formattedEndTimeAdvisor || defaultTimeEnd)
      this.$set(this, 'formattedEndTimeBot', chatSettings.formattedEndTimeBot || defaultTimeEnd)

      if (!Array.isArray(chatSettings.formFields)) this.$set(this.chat, 'formFields', [])

      if (!chatSettings.workingHours) {
        this.$set(this.chat, 'workingHours', {
          blockMessageComposer: false,
          days: [
            { code: 0, isClosed: false, schedules: [] },
            { code: 1, isClosed: false, schedules: [] },
            { code: 2, isClosed: false, schedules: [] },
            { code: 3, isClosed: false, schedules: [] },
            { code: 4, isClosed: false, schedules: [] },
            { code: 5, isClosed: false, schedules: [] },
            { code: 6, isClosed: false, schedules: [] }
          ],
          enable: false,
          message: ''
        })
      }

      this.appTags = this.$store.getters.appTags
      if (!this.chat.urlsAutoOpen) this.chat.urlsAutoOpen = []
      this.textOfTermsAndConditions = this.chat.textOfTermsAndConditions || ''

      this.loadingSettings = false
    } catch (e) {
      console.log(e)
      this.errorLoadingSettings = true
      this.loadingSettings = false
    }

    await this.getConnectedEmails()
  },
  data () {
    return {
      authMethodItems: [
        { label: this.$t('general.noAuthentication'), value: 'none' },
        { label: this.$t('general.externalAuthentication'), value: 'external' },
        { label: this.$t('general.form'), value: 'form' }
      ],
      authMethodTwoFactor: [
        { label: this.$t('general.onDemand'), value: 'onDemand' },
        { label: this.$t('general.onStartup'), value: 'onStartup' }
      ],
      connectedEmails: [],
      errorLoadingSettings: false,
      gmailIsConnected: false,
      loadingSettings: false,
      tab: null,
      days: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ],
      languageItems: [
        { text: 'Español', value: 'es' },
        { text: 'Inglés', value: 'en' }
      ],
      validTimes: true,
      showTimePicker: '',
      timePickerValue: '',
      typeLinks: ['Keybe', 'Términos y condiciones de tu aplicación'],
      selectedSchedule: '',
      appTags: [],
      timeRules: {
        checkHours: (from, until) => {
          return this.isBefore(from, until) || `${this.$t('general.youMustChooseAfter')} ${from}`
        }
      },
      rules,
      timeZones,
      chat: {
        advisorInactivity: false,
        advisorInactivityMessage: '',
        advisorInactivityMessageDelayTime: null,
        authMethod: 'none',
        authorizationTimeout: 60,
        authTwoFactor: '',
        urlsAutoOpen: [],
        customFormTitle: '',
        customizedQuestions: [],
        customizedEndTimeAdvisor: null,
        customizedEndTimeBot: null,
        customizedEndReasonAdvisor: '',
        customizedEndReasonBot: '',
        disableMultimedia: false,
        enableInactivity: false,
        endUnansweredConversations: false,
        finishOptions: [],
        formFields: [],
        formattedEndTimeAdvisor: '00:00',
        formattedReady4Time: '00:00',
        formattedAdvisorTime: '00:00',
        formattedEndTimeBot: '00:00',
        textOfTermsAndConditions: '',
        hidePoweredByKeybe: false,
        htmlOfTermsAndConditions: '',
        inactivityMessage: '',
        inactivitySeconds: 30,
        language: 'es',
        linkOfTermsAndConditions: '',
        logo: '',
        mainColor: '#3b3b3b',
        permanentMessages: [],
        position: 'right',
        ready4InactivityMessage: '',
        ready4InactivityMessageDelayTime: null,
        quickResponses: [],
        showConnectedAdvisorsOnly: false,
        showTermsAndConditions: false,
        termsAndConditionsLinkColor: '',
        timeZone: {
          label: 'America/Bogota',
          offset: '−05:00'
        },
        urlBase: '',
        workingHours: {
          blockMessageComposer: false,
          days: [
            { code: 0, isClosed: false, schedules: [] },
            { code: 1, isClosed: false, schedules: [] },
            { code: 2, isClosed: false, schedules: [] },
            { code: 3, isClosed: false, schedules: [] },
            { code: 4, isClosed: false, schedules: [] },
            { code: 5, isClosed: false, schedules: [] },
            { code: 6, isClosed: false, schedules: [] }
          ],
          enable: false,
          message: ''
        },
        showEmojis: false,
        automaticallyAssignAdvisorsWaitingForConversations: false,
        theme: 'light',
        title: ''
      },
      assignChange: false,
      formattedAdvisorTime: '00:00',
      formattedReady4Time: '00:00',
      formattedEndTimeAdvisor: '00:00',
      formattedEndTimeBot: '00:00',
      loading: false,
      loadingGmail: false,
      showSchedulePickerDialog: false,
      showAttachChatDialog: false,
      showChat: false,
      showMenuTime: false,
      textOfTermsAndConditions: ''
    }
  },
  methods: {
    addLink (link) {
      if (link === 'Keybe') {
        this.textOfTermsAndConditions += '{{keybe}}'
      } else {
        this.textOfTermsAndConditions += '{{app}}'
      }
    },
    isBefore (from, until) {
      if (!from || !until) return true
      const fromMoment = moment(from, 'HH:mm')
      const untilMoment = moment(until, 'HH:mm')
      return fromMoment.isBefore(untilMoment)
    },
    closeTimePicker () {
      this.showTimePicker = false
    },
    async connectionWithGmail () {
      try {
        this.loadingGmail = true
        const appUUID = this.$store.getters.appUuid
        const companyUUID = this.$store.getters.companyUuid

        const response = await conversationsService.connectionWithGmail(companyUUID, appUUID, this.gmailIsConnected)

        if (!response.success) {
          notifications.error(response.error)
          this.loadingGmail = false
          return
        }

        notifications.success(this.gmailIsConnected ? this.$t('general.correctlyEmailConnection') : this.$t('general.correctlyEmailDisconnection'))
        this.gmailIsConnected = response.enabled
        this.loadingGmail = false
      } catch (error) {
        notifications.error(error.message)
        this.loadingGmail = false
      }
    },
    connectWithGoogle () {
      this.$router.push({
        name: 'Detalles',
        params: {
          companyid: this.$store.getters.companyUuid,
          appid: this.$store.getters.appUuid
        }
      }).catch(() => {})
    },
    async getConnectedEmails () {
      const appUUID = this.$store.getters.appUuid
      const companyUUID = this.$store.getters.companyUuid
      const response = await conversationsService.getConnectedEmails(companyUUID, appUUID)

      if (!response.success) return
      this.connectedEmails = response.emails

      if (response.emails.length > 0) {
        await this.getWatchingEmail()
      }
    },
    getParamsFromURL (url) {
      return decodeURIComponent(new URL(url).search.substr(1))
        .split('&')
        .reduce((acc, cur) => {
          const [key, value] = cur.split('=')
          acc[key] = value
          return acc
        }, {})
    },
    async getWatchingEmail () {
      try {
        const appUUID = this.$store.getters.appUuid
        const companyUUID = this.$store.getters.companyUuid

        this.gmailIsConnected = await conversationsService.getWatchingEmail(companyUUID, appUUID)
      } catch (e) {
        console.log(e.message)
        this.gmailIsConnected = false
      }
    },
    openTimePicker (day, schedule, selection) {
      this.selectedSchedule = { day, schedule, selection }
      this.timePickerValue = this.chat.workingHours.days[day].schedules[schedule][selection]
      this.showTimePicker = true
    },
    reload () {
      window.location.reload()
    },
    saveSchedule () {
      const v = this.selectedSchedule
      this.chat.workingHours.days[v.day].schedules[v.schedule][v.selection] = this.timePickerValue
      this.showTimePicker = false
    },
    async submit (value) {
      if (this.chat.endUnansweredConversations) {
        if (this.showErrorTime) {
          return notifications.error(this.$t('general.timeMustBeGreaterThan15MinutesAndLessThan9Hours'))
        }
      }
      if (this.showErrorTimeInactivity) {
        if (this.chat.advisorInactivity) {
          notifications.error(this.$t('general.completionTimeCannotBeLessThanIdleTime'))
          return
        }
      }

      const regex = /{{keybe}}/
      if (this.chat.showTermsAndConditions && !regex.test(this.textOfTermsAndConditions)) {
        return notifications.error(this.$t('general.youMustIncludeAtLeastTheKeybeLinkInTheTermsAndConditions'))
      }

      this.chat.htmlOfTermsAndConditions = this.htmlOfTermsAndConditions
      this.chat.textOfTermsAndConditions = this.textOfTermsAndConditions

      try {
        this.loading = true
        const extradata = [
          {
            access: 'public',
            field: value,
            value: value === 'chat' ? this.chat : this.appTags
          }
        ]

        // check schedule
        let badSchedule = false

        this.chat.workingHours.days.forEach(day => {
          if (day.isClosed) return
          return day.schedules.forEach((schedule, index) => {
            if (!this.isBefore(index > 0 ? day.schedules[index - 1].until : '00:00', schedule.from)) badSchedule = true
            if (!this.isBefore(schedule.from, schedule.until)) badSchedule = true
          })
        })

        if (badSchedule) {
          this.loading = false
          return notifications.error(this.$t('general.checkTheWorkSchedule'))
        }

        const companyId = this.$store.getters.companyUuid
        const appId = this.$store.getters.appUuid
        const token = this.$store.getters.token
        const data = { extradata: extradata }

        await this.$store.dispatch('updateApp', { companyId, appId, data })

        this.loading = false
        let deleteWaitingAdvisor = false
        if (this.assignChange && !this.chat.automaticallyAssignAdvisorsWaitingForConversations) {
          deleteWaitingAdvisor = true
        }
        await this.$store.dispatch('updateCache', deleteWaitingAdvisor)

        if (this.isSuperAdmin && this.chat.endUnansweredConversations) {
          await conversationsService.createEndConversationAgent(token, companyId, appId)
        } else if (this.isSuperAdmin) {
          await conversationsService.deleteEndConversationAgent(token, companyId, appId)
        }

        if (this.isSuperAdmin && this.chat.advisorInactivity) {
          await conversationsService.createInactivityMessageAgent(token, companyId, appId)
        } else if (this.isSuperAdmin) {
          await conversationsService.deleteInactivityMessageAgent(token, companyId, appId)
        }

        notifications.success(this.$t('general.configurationSavedSuccessfully'))
      } catch (e) {
        this.loading = false
        notifications.error(e.message)
      }
    },
    addSchedule (day) {
      if (!Array.isArray(day.schedules)) {
        this.$set(day, 'schedules', [])
        day.schedules.push({ from: '', until: '' })
        return
      }

      if (day.schedules.length === 4) return

      const backSchedule = day.schedules[day.schedules.length - 1]

      if (backSchedule && (!backSchedule.from || !backSchedule.until)) return
      day.schedules.push({ from: '', until: '' })
    },
    toMilliseconds (value) {
      const time = value.split(':')
      return ((time[0] * 3600) + (time[1] * 60)) * 1000
    },
    removeSchedule (day, index) {
      day.schedules.splice(index, 1)
    }
  },
  watch: {
    formattedEndTimeAdvisor (newVal) {
      this.chat.customizedEndTimeAdvisor = this.toMilliseconds(newVal)
      this.chat.formattedEndTimeAdvisor = newVal
    },
    formattedAdvisorTime (newVal) {
      this.chat.advisorInactivityMessageDelayTime = this.toMilliseconds(newVal)
      this.chat.formattedAdvisorTime = newVal
    },
    formattedReady4Time (newVal) {
      this.chat.ready4InactivityMessageDelayTime = this.toMilliseconds(newVal)
      this.chat.formattedReady4Time = newVal
    },
    formattedEndTimeBot (newVal) {
      this.chat.customizedEndTimeBot = this.toMilliseconds(newVal)
      this.chat.formattedEndTimeBot = newVal
    }
  }
}
</script>

<style>
  .terms-and-conditions-settings a {
    font-weight: bold;
    text-decoration: none;
  }

  .timeInput {
    border-bottom: solid #2DCE98 !important;
    height: 40px;
    width: 60px;
  }
  .vue__time-picker input.display-time {
    width: 80px;
    border: none;
  }
  .timeInput:focus {
    outline: none;
  }
  .avatar-image-chat {
    width: 30px;
  }

  .kb-chat-container {
    background-color: white;
    border-radius: 5px;
    bottom: 16px;
    display: flex;
    flex-direction: column;
    height: 70%;
    max-width: 92%;
    position: fixed;
    right: 16px;
    width: 400px;
    z-index: 2147483648;
  }

  .chat-footer {
    background-color: #f0f0f0;
    border-radius: 0 0 5px 5px;
    max-height: 56px;
  }

  .chat-header {
    background-color: #3b3b3b;
    border-radius: 5px 5px 0 0;
    max-height: 56px;
  }

  .color-show {
    display: inline;
    width: 50px;
    min-width: 50px;
    height: 50px;
    background-color: black;
    border-radius: 50%
  }

  .kb-toggle-button {
    background: rgb(59,59,59);
    border-radius: 50%;
    bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 64px;
    position: fixed;
    right: 32px;
    width: 64px;
    z-index: 201 !important;
  }

  .kb-customized-question-title {
    font-weight: bold;
    padding: 10px;
  }

  .kb-header__custom-text {
    color: white;
    font-weight: bold;
    font-size: 16px;
    margin-left: 16px;
  }

  .kb-toggle-button__pulse {
    /* pulse from: https://codepen.io/olam/pen/zcqea */
    border-radius: 50%;
    box-shadow: 0 0 0 rgba(59, 59, 59, 0.4);
    animation: pulse 2s infinite;
  }

  @-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 rgba(59, 59, 59, 0.4);
    }
    70% {
      -webkit-box-shadow: 0 0 0 35px rgba(59, 59, 59, 0);
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 rgba(59, 59, 59, 0);
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 rgba(59, 59, 59, 0.4);
      box-shadow: 0 0 0 0 rgba(59, 59, 59, 0.4);
    }
    70% {
      -moz-box-shadow: 0 0 0 35px rgba(59, 59, 59, 0);
      box-shadow: 0 0 0 35px rgba(59, 59, 59, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(59, 59, 59, 0);
      box-shadow: 0 0 0 0 rgba(59, 59, 59, 0);
    }
  }

  .expand-y-enter-active,
  .expand-y-leave-active {
    transition: all 0.2s;
    max-height: 31px;
  }
  .expand-y-enter,
  .expand-y-leave-to
  {
    opacity: 0;
    max-height: 0;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(56px);
    opacity: 0;
  }
  .custom-expansion-panels .v-expansion-panel::before {
    box-shadow: none;
  }
</style>
